import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Map } from 'immutable';

import {
  Node,
  Taxonomy as TaxonomyTerm,
  entityGetByPath,
  ContextualActionsWrapper,
  entityReset,
  referenceLoadingReset,
} from '@uncinc/react-drupal-core';

import {
  HTTP_STATUS_PAGE_NOT_FOUND,
  HTTP_STATUS_PAGE_NO_ACCESS,
  HTTP_STATUS_SERVER_ERROR,
  HTTP_STATUS_SERVER_UNAVAILABLE,
} from '../../config/constants';
import Page from '../Page';
import NotFound from '../NotFound';
import { usePrevious } from '../../helpers/usePrevious';

const Entity = () => {
  const dispatch = useDispatch();

  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const prevPath = usePrevious(path);
  const entityNotLoaded = !entityType || !entityId;
  const pathIsDifferentAndHasEntity = (path !== prevPath && typeof prevPath !== 'undefined') && (typeof entityStatus !== 'undefined' && entityStatus !== null);

  useEffect(() => {
    if (entityNotLoaded || (!entityNotLoaded && pathIsDifferentAndHasEntity)) {
      dispatch(referenceLoadingReset());
      dispatch(entityGetByPath(path));
    }
  }, [dispatch, entityNotLoaded, pathIsDifferentAndHasEntity, path]);

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }

  if (entityStatus === HTTP_STATUS_PAGE_NOT_FOUND
    || entityStatus === HTTP_STATUS_PAGE_NO_ACCESS
    || entityStatus === HTTP_STATUS_SERVER_ERROR
    || entityStatus === HTTP_STATUS_SERVER_UNAVAILABLE) {
    return (
      <NotFound status={entityStatus} />
    );
  }

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }
  return (
    <ContextualActionsWrapper>
      <Page title={childEntity.getIn(['title', 0, 'value'], '')} path={path} prevPath={prevPath}>
        {entityType === 'node' && (
          <Node root id={entityId} />
        )}
        {entityType === 'taxonomy_term' && (
          <TaxonomyTerm root id={entityId} />
        )}
      </Page>
    </ContextualActionsWrapper>
  );
};

export default Entity;
